import classNames from 'classnames'

import { StringText } from '@/Atomic/Atoms/StringText'
import { FileIcon } from '@/Atomic/Molecules/FileIcon'

import './FileFormatBadge.scss'

interface FileFormatBadgeProps {
  format?: string
  className?: string
}

export const FileFormatBadge: React.FC<FileFormatBadgeProps> = ({
  format,
  className,
}) => {
  const normalized = (format || '').trim()
  if (!normalized) return null

  return (
    <span className={classNames('file-format-badge', className)}>
      <FileIcon extension={normalized} />
      <StringText className="file-format-text" value={normalized} />
    </span>
  )
}
